export default __webpack_public_path__ + "static/media/potion5.c5e920b3.png";